import { handleResponse } from './apiUtil';
import http from './http-common';



export const getAll = () => http.get('customer/all').then(handleResponse);
export const get = (customerId) => http.get(`customer/${customerId}`).then(handleResponse);
export const register = (data) =>
    http.post('customer/create', data).then(handleResponse);
export const update = (customerId, data) =>
    http.put(`customer/update/${customerId}`, data).then(handleResponse);
export const remove = (customerId) =>
    http.delete(`customer/delete/${customerId}`).then(handleResponse);
export const getTrackingById = (customerId,trackingId) => http.get(`customer/${customerId}/tracking/${trackingId}`).then(handleResponse);
export const getTrackings= (customerId)=> http.get(`customer/${customerId}/tracking/all`).then(handleResponse);
